


















































































import Vue from 'vue';
import { Resolve } from 'vue-di';
import { Component, Prop, Watch } from 'vue-property-decorator';
import EnrollmentModule from '~/store/enrollment';
import LayoutModule from '~/store/layout';

@Component<Footer>({})
export default class Footer extends Vue {
    @Resolve
    public layout!: LayoutModule;

    @Resolve
    public enrollment!: EnrollmentModule;

    @Prop()
    public brkPoints!: object;

    public get genzymeLogoSrc() {
        return this.layout.configuration.images.header || this.$settings.url(this.$settings.footerLogo);
    }

    // public useTextBasedOnEnrollmentPath() {
    //     if (this.$route.name === 'index') {
    //         return 'This site is intended for use by US residents only.';
    //     } else if (localStorage.getItem('enrollmentTypePatientOrHCP') === 'Patient') {
    //         return 'This site is intended for use by US residents only.';
    //     } else if (localStorage.getItem('enrollmentTypePatientOrHCP') === 'HCP') {
    //         return 'This site is intended for use by US healthcare professionals only.';
    //     } else {
    //         return;
    //     }
    // }

    // public useTextBasedOnDrugPath() {
    //     if (this.$route.name === 'selection') {
    //         return 'JEVTANA, ELITEK, SARCLISA, CareASSIST and Sanofi are registered trademarks of Sanofi or an affiliate.';
    //     } else if (localStorage.getItem('drugNamePath') === 'elitek') {
    //         return 'ELITEK, CareASSIST, and Sanofi are registered trademarks of Sanofi or an affiliate.';
    //     } else if (localStorage.getItem('drugNamePath') === 'jevtana') {
    //         return 'JEVTANA, CareASSIST, and Sanofi are registered trademarks of Sanofi or an affiliate.';
    //     } else if (localStorage.getItem('drugNamePath') === 'sarclisa') {
    //         return 'SARCLISA, CareASSIST, and Sanofi are registered trademarks of Sanofi or an affiliate.';
    //     } else {
    //         return 'CareASSIST and Sanofi are registered trademarks of Sanofi or an affiliate.';
    //     }
    // }

    // public checkIfNonDrugPath() {
    //     if (this.$route.name === 'index' || this.$route.name === 'selection' || this.$route.name === 'reimbursement') {
    //         return true;
    //     } else {
    //         return false;
    //     }
    // }
    // public dynamicStyleFooterLogo() {
    //     if (this.checkIfNonDrugPath()) {
    //         return {
    //             position: 'relative',

    //         };
    //     } else {
    //         return {};
    //     }
    // }

    // public checkElitekEnrollmentPatient() {
    //     if (this.checkIfNonDrugPath()) {
    //         return false;
    //     }
    //     if (localStorage.getItem('enrollmentTypePatientOrHCP') === 'Patient') {
    //         if (localStorage.getItem('drugNamePath') === 'elitek') {
    //             return true;
    //         }
    //         return false;
    //     }
    //     return false;
    // }
    // public checkElitekEnrollmentHCP() {
    //     if (this.checkIfNonDrugPath()) {
    //         return false;
    //     }
    //     if (localStorage.getItem('enrollmentTypePatientOrHCP') === 'HCP') {
    //         if (localStorage.getItem('drugNamePath') === 'elitek') {
    //             return true;
    //         }
    //         return false;
    //     }
    //     return false;
    // }
    // public checkJevtanaEnrollmentPatient() {
    //     if (this.checkIfNonDrugPath()) {
    //         return false;
    //     }
    //     if (localStorage.getItem('enrollmentTypePatientOrHCP') === 'Patient') {
    //         if (localStorage.getItem('drugNamePath') === 'jevtana') {
    //             return true;
    //         }
    //         return false;
    //     }
    //     return false;
    // }
    // public checkJevtanaEnrollmentHCP() {
    //     if (this.checkIfNonDrugPath()) {
    //         return false;
    //     }
    //     if (localStorage.getItem('enrollmentTypePatientOrHCP') === 'HCP') {
    //         if (localStorage.getItem('drugNamePath') === 'jevtana') {
    //             return true;
    //         }
    //         return false;
    //     }
    //     return false;
    // }
    // public checkSrclisaEnrollmentPatient() {
    //     if (this.checkIfNonDrugPath()) {
    //         return false;
    //     }
    //     if (localStorage.getItem('enrollmentTypePatientOrHCP') === 'Patient') {
    //         if (localStorage.getItem('drugNamePath') === 'sarclisa') {
    //             return true;
    //         }
    //         return false;
    //     }
    //     return false;
    // }
    // public checkSarclisaEnrollmentHCP() {
    //     if (this.checkIfNonDrugPath()) {
    //         return false;
    //     }
    //     if (localStorage.getItem('enrollmentTypePatientOrHCP') === 'HCP') {
    //         if (localStorage.getItem('drugNamePath') === 'sarclisa') {
    //             return true;
    //         }
    //         return false;
    //     }
    //     return false;
    // }
}
